<template>
  <!-- privacy policy acceptance screen when logging into the system for the first time, or if there is a change in policy -->

  <div
    class="modal bd-example-modal-lg"
    tabindex="-1"
    data-keyboard="false"
    data-backdrop="static"
    role="dialog"
    id="bannerModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" style="margin-top: 5%">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            id="closeBanner"
            @click="nextBanner"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <a :href="this.currentBanner.bnt_link" target="blank">
            <img
              width="100%"
              :src="this.currentBanner.bnt_imagem"
              class="banner-desktop"
              alt="imagem-banner"
              height="100%"
            />
            <img
              :src="this.currentBanner.bnt_imagem_mobile"
              class="banner-mobile"
              alt="imagem-banner"
            />
          </a>
        </div>
        <div class="footer-style"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",

  data() {
    return {
      checked: false,
      currentBanner: { bnt_imagem: "", bnt_link: "", bnt_imagem_mobile: "" },
      bannerCookie: [],
      mapBanner: [],
      width: window.innerWidth > 0 ? window.innerWidth : screen.width,
      userLogged: JSON.parse(localStorage.userLogged)
    };
  },
  props: ["banners"],

  methods: {
    nextBanner: function () {
      this.bannerCookie.push(`${this.userLogged.usu_id}_${this.currentBanner.bnt_imagem}`);

      this.$cookies.set("banners", JSON.stringify(this.bannerCookie), "100d");
      if (
          this.mapBanner.length > 0 &&
          (this.width <= 480 && this.mapBanner[this.mapBanner.length - 1].bnt_imagem_mobile)
      ) {
        this.currentBanner = this.mapBanner.pop();
      } else {
        $("#bannerModal").hide();
      }
    },
  },

  mounted() {
    this.bannerCookie = JSON.parse(this.$cookies.get("banners")) || [];

    this.mapBanner = this.banners.filter((banner) => {
      return this.bannerCookie.indexOf(`${this.userLogged.usu_id}_${banner.bnt_imagem}`) < 0;
    });

    //Se não existir banner Mobile passa para o próximo banner
    let flagNextMobile = false;
    while (
      this.width <= 480 &&
      !this.currentBanner.bnt_imagem_mobile &&
      this.mapBanner.length
    ) {
      this.currentBanner = this.mapBanner.pop();
      if (this.currentBanner.bnt_imagem_mobile) {
        flagNextMobile = true;
      }
    }

    if (this.mapBanner.length && !flagNextMobile) {
      this.currentBanner = this.mapBanner.pop();
      $("#bannerModal").show();
    } else if (flagNextMobile) {
      $("#bannerModal").show();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.access {
  color: #fff;
  width: 20%;
  height: 20%;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  margin-right: 25px;
  margin-top: -13px;
}
.img-align {
  display: flex;
  justify-content: center;
}
.footer-style {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.modal {
  color: rgb(100, 95, 95);
}

label {
  margin-left: 40px;
  margin-left: 35px;
}

.modal-content {
  padding: 5px;
  background-color: transparent;
  border: none;
}
.modal-header {
  border: none;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  font-family: sans-serif !important;
  font-size: 14px;
}
.close {
  font-size: 40px;
  margin-top: -8%;
  margin-right: -2%;
  color: #fff;
}

.banner-mobile {
  display: none;
}

@media only screen and (max-device-width: 480px) {
  .banner-mobile {
    display: block;
  }
  .banner-desktop {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/Banner.vue